import React from 'react'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText,
  EuiSpacer
} from '@elastic/eui'


import ivImage01 from '../../../../../images/Software/Windows/InstarVision/Camera_List/Image079.png'
import ivImage02 from '../../../../../images/Software/Windows/InstarVision/Camera_List/Image080.png'
import ivImage03 from '../../../../../images/Software/Windows/InstarVision/Camera_List/Image081.png'
import ivImage04 from '../../../../../images/Software/Windows/InstarVision/Camera_List/Image084.png'

export default function ImageCard() {

  return (
    <React.Fragment>
      <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
        <EuiFlexItem>
          <EuiCard
            textAlign="left"
            image={
              <div>
                <img
                  src={ivImage01}
                  alt="INSTAR InstarVision v2 for Windows"
                />
              </div>
            }
            title="Hinzufügen"
            footer={
              <EuiText>
                <p>Fügen Sie eine Karte hinzu, indem Sie einen Rechtsklick auf Karte ausführen.</p>
              </EuiText>
            }
          />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiCard
            textAlign="left"
            image={
              <div>
                <img
                  src={ivImage02}
                  alt="INSTAR InstarVision v2 for Windows"
                />
              </div>
            }
            title="Löschen"
            footer={
              <EuiText>
                <p>Löschen Sie eine Karte, indem Sie sie rechtsklicken.</p>
              </EuiText>
            }
          />
        </EuiFlexItem>
      </EuiFlexGroup>

      <EuiSpacer />

      <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
        <EuiFlexItem>
          <EuiCard
            textAlign="left"
            image={
              <div>
                <img
                  src={ivImage03}
                  alt="INSTAR InstarVision v2 for Windows"
                />
              </div>
            }
            title="Umbenennen"
            footer={
              <EuiText>
                <p>Klicken Sie 2 x um den Namen zu ändern - ein Doppelklick öffnet die Kartenansicht.</p>
              </EuiText>
            }
          />
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiCard
            textAlign="left"
            image={
              <div>
                <img
                  src={ivImage04}
                  alt="INSTAR InstarVision v2 for Windows"
                />
              </div>
            }
            title="Bearbeiten"
            footer={
              <EuiText>
                <p>Ziehen Sie die Kameras aus Ihrer Kamera Liste auf die Karte.</p>
              </EuiText>
            }
          />
        </EuiFlexItem>
      </EuiFlexGroup>
    </React.Fragment>
  );
}
